export default __webpack_public_path__ + "static/P_SearchThumb_IN-W1-d5b164f41fa4a39555de1db3e0ef642d.webp";